import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import './style.scss';

const Component = ({
  label = '',
  controlId = '',
  type = '',
  hint = '',
  required = false,
  async = false,
  ...props
}) => {
  return (
    <Form.Group className="mb-2" controlId={controlId}>
      <Form.Label className="text-sm text-slate-600 font-bold tracking-wide mb-0">
        {label}
        {required && <span className="text-red-600"> *</span>}
      </Form.Label>
      {async ? (
        <AsyncSelect classNamePrefix="select" {...props} />
      ) : (
        <Form.Select classNamePrefix="select" {...props} />
      )}
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
    </Form.Group>
  );
};

Component.propTypes = {
  label: PropTypes.string,
  controlId: PropTypes.string,
  type: PropTypes.string
};

export default Component;
